export default {
    baseStyle: {
        cartContainer: {
            maxWidth: {base: '100%', lg: '1260px'},
            margin: '0 auto',
            padding: {base: '24px 0', lg: '52px 0'}
        },
        cartTitle: {
            color: 'black',
            fontSize: '26px',
            fontWeight: 'extrabold',
            lineHeight: 'normal',
            margin: '0',
            fontFamily: 'crunchyrollatyp bold'
        },
        cartSelectBox: {
            height: '28px',
            fontSize: 'sm',
            cursor: 'pointer',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '12px 11px',
            backgroundPosition: 'center right',
            fontWeight: 'bold',
            border: 'none'
        },
        productCartBlock: {
            borderStyle: 'solid',
            borderWidth: '0 0 1px 0',
            borderColor: 'softSand',
            borderRadius: 'unset',
            marginBottom: '0',
            padding: '16px 0'
        },
        cartItemDetailsBlock: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            flex: '1 0 0',
            alignSelf: {base: 'unset', md: 'stretch'}
        },
        cartItemTitleBlock: {
            alignItems: 'flex-start',
            gap: {base: 1, md: 4},
            alignSelf: 'stretch',
            justifyContent: 'space-between',
            flexDirection: {base: 'column', md: 'row'}
        },
        cartItemButtonsBlock: {
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            flexDirection: {base: 'column', md: 'row'}
        },
        cartItemButton: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'normal',
            color: 'black',
            margin: '0 !important',
            padding: 0
        },
        productName: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: {base: 'md', md: 'xl'},
            fontWeight: 'bold',
            lineHeight: 'normal'
        },
        cartSizeLabel: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'sm',
            fontWeight: 'bold',
            lineHeight: 4,
            pt: '3px',
            pr: '1px'
        },
        securePaymenttext: {
            fontFamily: "'DM Sans', sans-serif",
            color: 'darkGray',
            fontSize: 'xs',
            fontWeight: 500,
            lineHeight: 5
        },
        checkoutBtnBlock: {
            position: {base: 'fixed', sm: 'unset'},
            padding: {base: 4, sm: '0'},
            background: {base: 'primaryBgColor', sm: 'unset'},
            boxShadow: {base: '0 -2px 4px 0 rgba(0, 0, 0, 0.20)', sm: 'unset'},
            left: 0,
            bottom: 0,
            width: '100%',
            zIndex: 9,
            display: 'flex',
            gap: 2,
            flexDirection: 'column'
        },
        saveLaterblock: {
            mt: '56px',
            width: {sm: 'calc(100% - 360px)'}
        },
        preorderText: {
            color: 'darkOrange',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: 'normal'
        },
        productPromotionsCallout: {
            color: 'pomegranateBase',
            textAlign: 'right',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: 'normal'
        },
        outOfStockText: {
            mt: 1,
            color: 'darkOrange',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: 'normal'
        },
        outOfItemAlertBlock: {
            display: 'flex',
            padding: 3,
            alignItems: 'flex-start',
            gap: 2,
            borderRadius: 'lg',
            background: 'dutchWhite',
            mb: 6
        },
        outOfItemAlertHeading: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'xl',
            fontWeight: 'bold',
            lineHeight: '6',
            letterSpacing: '-0.6px'
        },
        outOfItemAlertText: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: '22px'
        },
        outOfItemAlertClose: {
            position: 'absolute',
            right: 0,
            top: 0,
            bg: 'unset',
            p: 0,
            w: '12px',
            h: '12px !important',
            minW: 'unset',
            _hover: {
                bg: 'unset'
            }
        },
        orderSummaryTotal: {
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'extrabold',
            fontSize: 'xl',
            lineHeight: 7
        },
        membershipPromoMsg: {
            color: 'darkGreen',
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'normal',
            lineHeight: 'normal',
            letterSpacing: '-0.32px'
        },
        membershipSignup: {
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 'md',
            fontWeight: 'bold',
            lineHeight: '22px',
            textDecoration: 'underline'
        }
    }
}
